var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('statistic-card-horizontal',{attrs:{"icon":"DollarSignIcon","color":"success","statistic":_vm.totalIncome,"statistic-title":_vm.$t(_vm.label)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }